function GlassCard({ children, className = '', as: Tag = 'section', ...rest }) {
  return (
    <Tag
      className={`glass-panel relative overflow-hidden rounded-3xl ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default GlassCard;